import { motion } from 'framer-motion';
import Card from '../components/Card';
import scholarLinks from '../data/scholarLinks';

// Grid elemanları için animasyon
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.1 }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: { y: 0, opacity: 1 }
};

export default function Links() {
  const otherLinks = [
    { name: "Ahi Evran Üniversitesi", url: "https://www.ahievran.edu.tr", description: "Üniversite resmi web sitesi", icon: "🏛️" },
    { name: "Araştırma Laboratuvarı", url: "#", description: "Yapay Zeka ve Makine Öğrenmesi Laboratuvarı", icon: "🔬" }
  ];

  return (
    <div className="min-h-screen bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <motion.h1 
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-5xl md:text-6xl font-serif font-bold text-navy mb-4 tracking-tight"
          >
            Bağlantılar
          </motion.h1>
          <motion.div 
            initial={{ width: 0 }}
            animate={{ width: "6rem" }}
            transition={{ duration: 0.8 }}
            className="h-1 bg-gradient-to-r from-transparent via-navy to-transparent mx-auto mb-4"
          ></motion.div>
        </div>

        {/* Scholar Links */}
        <div className="mb-12">
          <h2 className="text-3xl font-serif font-bold text-navy mb-8 text-center md:text-left">Akademik Profiller</h2>
          <motion.div 
            variants={containerVariants}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
          >
            {scholarLinks.map((link) => (
              <motion.a
                key={link.name}
                variants={itemVariants}
                href={link.url}
                className="bg-white rounded-xl border-2 border-gray-200 flex items-center gap-4 p-5 text-navy group"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ y: -5, boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1)", borderColor: "#001f3f" }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <span className="text-3xl group-hover:scale-110 transition-transform duration-300">{link.icon}</span>
                <div className="flex-1">
                  <p className="font-semibold group-hover:underline">{link.name}</p>
                </div>
                <motion.svg 
                  className="w-5 h-5 text-navy" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                  initial={{ opacity: 0, x: -10 }}
                  whileHover={{ opacity: 1, x: 0 }}
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                </motion.svg>
              </motion.a>
            ))}
          </motion.div>
        </div>

        {/* Other Links */}
        <div>
          <h2 className="text-3xl font-serif font-bold text-navy mb-8 text-center md:text-left">Diğer Bağlantılar</h2>
          <motion.div 
             variants={containerVariants}
             initial="hidden"
             whileInView="visible"
             viewport={{ once: true }}
             className="grid grid-cols-1 md:grid-cols-2 gap-6"
          >
            {otherLinks.map((link, index) => (
              <motion.div 
                variants={itemVariants}
                key={index} 
                className="bg-white rounded-xl border-2 border-gray-200 p-6 hover:shadow-xl transition-all duration-300"
                whileHover={{ y: -5, borderColor: "#001f3f" }}
              >
                <a
                  href={link.url}
                  className="flex items-start gap-4 group"
                  target={link.url.startsWith('http') ? '_blank' : undefined}
                  rel={link.url.startsWith('http') ? 'noopener noreferrer' : undefined}
                >
                  <span className="text-4xl group-hover:scale-110 transition-transform">{link.icon}</span>
                  <div className="flex-1">
                    <h3 className="text-xl font-serif font-bold text-navy mb-2 group-hover:underline">
                      {link.name}
                    </h3>
                    <p className="text-gray-600">{link.description}</p>
                  </div>
                  <motion.svg 
                    className="w-5 h-5 text-navy mt-1" 
                    fill="none" 
                    stroke="currentColor" 
                    viewBox="0 0 24 24"
                    initial={{ opacity: 0 }}
                    whileHover={{ opacity: 1, x: 5 }}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                  </motion.svg>
                </a>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </div>
  );
}